export default Object.freeze({
  FOPLIST: 'FOPLIST',
  BOP: 'BOP',
  MINI_TROLLEY: 'MINI_TROLLEY',
  TROLLEY_SIDEBAR: 'TROLLEY_SIDEBAR',
  SO_SB_BULK_ADD: 'SO_SB_BULK_ADD',
  CHECKOUTPURGE: 'CHECKOUTPURGE',
  EXTERNAL: 'EXTERNAL', // added via basked:add/basket:remove events
});
